export default function authMixin(hybrid) {
  var hybridJs = hybrid;
  hybridJs.extendModule('auth', [{
    // 获取token
    namespace: 'getToken',
    os: ['ywk']
  }, {
    namespace: 'config',
    os: ['ywk'],
    params: {
      // 一个数组，不要传null，否则可能在iOS中会有问题
      jsApiList: []
    }
  }]);
}